import { Box, Token } from '@usealloy/component-library';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const EvaluationDetailWrapper = styled.div`
  width: 100%;

  .evaluation-detail {
    padding: 0;
  }
`;

export const FontSizeBox = styled(Box)`
  &&&& {
    font-size: var(--cl-font-size-2);
  }
`;

export const StyledLink = styled(Link)`
  font-weight: var(--cl-font-weight-normal);
  text-transform: none;
  margin: 0;
`;

export const StyledJourneyLink = styled(StyledLink)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledToken = styled(Token)`
  align-self: flex-end;
  max-width: fit-content;
  min-width: 100px;
`;

export const StyledDownloadLink = styled.a`
  font-size: var(--cl-font-size-2);
  line-height: var(--cl-line-height-2);
`;
